import React, { useEffect } from "react";
import image1 from "../images/project-img-8.jpg";
import image2 from "../images/pexels-kaboompics-com-6253.jpg";
import image3 from "../images/project-img-6.jpg";
import image4 from "../images/project-img-7.jpg";
import logo from "../images/hero-img.png";
import Aos from "aos";
import "aos/dist/aos.css";

function Blog() {
  useEffect(() => {
    Aos.init({ duration: 500 });
  }, []);
  return (
    <>
      <section className="section blog" data-aos="fade-in">
        <div className="section-title">
          <h2>blog</h2>
          <div className="underline"></div>
        </div>

        <div className="section-center blog-center" data-aos="fade-in">
          <div className="card" data-aos="fade-in">
            <div className="card-side card-front">
              <img className="f" src={image4} alt="" />
              <div className="card-info">
                <h4>Graphql</h4>
                <p>Graphql Server with Mongoose</p>
                <div className="card-footer">
                  <img src={logo} alt="" /> <p>20 min read</p>
                </div>
              </div>
            </div>
            <h1>hello</h1>

            <div className="card-side card-back">
              <a href="https://github.com/juac08/graphql" className="btn">
                read more
              </a>
            </div>
          </div>
          <div className="card">
            <div className="card-side card-front">
              <img className="f" src={image3} alt="" />
              <div className="card-info">
                <h4>User Security</h4>
                <p>Login /Logout / Register / MongoDB / NodeJs / Security</p>
                <div className="card-footer">
                  <img src={logo} alt="" />
                  <p>15 min read</p>
                </div>
              </div>
            </div>

            <div className="card-side card-back">
              <a
                href="https://github.com/juac08/Authorization-"
                className="btn"
              >
                read more
              </a>
            </div>
          </div>

          <div className="card" data-aos="fade-in">
            <div className="card-side card-front">
              <img className="f" src={image2} alt="" />
              <div className="card-info">
                <h4>Menu React App</h4>
                <p>Fetch data, categories data and find on buttons.</p>
                <div className="card-footer">
                  <img src={logo} alt="" /> <p>5 min read</p>
                </div>
              </div>
            </div>

            <div class="card-side card-back">
              <a href="https://menu123.netlify.app" className="btn">
                read more
              </a>
            </div>
          </div>

          <div className="card" data-aos="fade-in">
            <div className="card-side card-front">
              <img className="f" src={image1} alt="" />
              <div className="card-info">
                <h4>RESTFull API</h4>
                <p>How to creat the RestFull API with nodejs.</p>
                <div className="card-footer">
                  <img src={logo} alt="" /> <p>12 min read</p>
                </div>
              </div>
            </div>

            <div className="card-side card-back">
              <a href="https://github.com/juac08/RESTFull-API" className="btn">
                read more
              </a>
            </div>
          </div>

          <div className="card" data-aos="fade-in">
            <div className="card-side card-front">
              <img className="f" src={image4} alt="" />
              <div className="card-info">
                <h4>Forms With Formik</h4>
                <p>How to create a reuseable forms with formik</p>
                <div className="card-footer">
                  <img src={logo} alt="" /> <p>20 min read</p>
                </div>
              </div>
            </div>

            <div className="card-side card-back">
              <a href="https://formswithformik.netlify.app" className="btn">
                read more
              </a>
            </div>
          </div>
          <div className="card" data-aos="fade-in">
            <div className="card-side card-front">
              <img className="f" src={image2} alt="" />
              <div className="card-info">
                <h4>Formik React</h4>
                <p>Forms with Formik Complete Lectures</p>
                <div className="card-footer">
                  <img src={logo} alt="" /> <p>20 min read</p>
                </div>
              </div>
            </div>

            <div className="card-side card-back">
              <a href="https://github.com/juac08/Formik.git" className="btn">
                read more
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Blog;
